<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <b-row>
            <vs-card>
              <b-row>
                <b-col cols="4">
                  <b-form-group label="İşlem Tipi" label-for="item-name">
                    <v-select
                      :options="[
                        'Sipariş',
                        'İade',
                        'İndirim',
                        'İptal',
                        'Vadesinden Önce Yapılan Ödeme',
                        'Virman',
                        'Trendyola Kesilen İade Faturaları',
                        'Hakedişler',
                        'Trendyolun Kestiği Faturalar',
                      ]"
                      v-model="selectIslemTipi"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group label="Başlangıç Tarihi" label-for="item-name">
                    <b-form-datepicker
                      id="datepickerbaslangic"
                      v-model="baslangic"
                      size="md"
                      local="en"
                      class="mb-2"
                      today-variant="danger"
                      placeholder="-"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group label="Bitiş Tarihi" label-for="item-name">
                    <b-form-datepicker
                      id="datepickerbaslangic"
                      v-model="bitis"
                      size="md"
                      local="en"
                      class="mb-2"
                      today-variant="danger"
                      placeholder="-"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </vs-card>
          </b-row>

          <b-row>
            <b-col cols="12" style="padding: 0; padding-right: 20px">
              <b-row align-h="start">
                <b-col cols="12" md="auto"
                  ><vs-button
                    style="border-radius: 5px"
                    color="success"
                    @click="finansmanCek(1)"
                    id="button-with-loading"
                    class="w-full vs-con-loading__container"
                    type="gradient"
                    >Bilgileri Çek</vs-button
                  >
                </b-col>
                <b-col cols="12" md="auto"
                  ><vs-button
                    style="border-radius: 5px"
                    color="danger"
                    @click="finansListele()"
                    type="gradient"
                    >Listele</vs-button
                  >
                </b-col>
                <b-col cols="12" md="auto"
                  ><vs-button
                    style="border-radius: 5px"
                    @click="analiz()"
                    id="button-with-loading1"
                    class="w-full vs-con-loading__container"
                    type="gradient"
                    >Analiz</vs-button
                  >
                </b-col>
                <b-col cols="12" md="auto">
                  <vs-button
                    style="border-radius: 5px"
                    color="#fc9551"
                    gradient-color-secondary="rgb(255, 115, 0)"
                    @click="analizListe()"
                    id="button-with-loading2"
                    class="w-full vs-con-loading__container"
                    type="gradient"
                    >Analiz Liste</vs-button
                  >
                </b-col>
                <b-col cols="12" md="auto">
                  <vs-button
                    style="border-radius: 5px"
                    color="#bc49c4"
                    gradient-color-secondary="rgb(110, 4, 138)"
                    @click="stokAnaliz()"
                    id="button-with-loading3"
                    class="w-full vs-con-loading__container"
                    type="gradient"
                    >Stok Analiz</vs-button
                  >
                </b-col>
                <b-col cols="12" md="auto">
                  <vs-button
                    style="border-radius: 5px"
                    color="#ea5455"
                    gradient-color-secondary="rgb(97, 1, 2)"
                    @click="acikFaturalar()"
                    id="button-with-loading3"
                    class="w-full vs-con-loading__container"
                    type="gradient"
                    >Açık Faturalar</vs-button
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div class="demo-alignment"></div>
        </vx-card>

        <vs-table search :data="data">
          <template slot="thead">
            <vs-th>İşlem</vs-th>
            <vs-th>Sipariş Numarası</vs-th>
            <vs-th>Sipariş Tarihi</vs-th>
            <vs-th>Borç</vs-th>
            <vs-th>Alacak</vs-th>
            <vs-th>Komisyon</vs-th>
            <vs-th>Ödeme Tarihi</vs-th>
            <vs-th>Ödeme Numarası</vs-th>
            <vs-th>Durumu</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <div
                  v-if="data[indextr].transactionType === 'İade'"
                  class="
                    con-vs-chip
                    product-order-status
                    vs-chip-warning
                    con-color
                  "
                  style="color: rgba(255, 255, 255, 0.9)"
                >
                  <span class="text-chip vs-chip--text">İade</span>
                </div>
                <div
                  v-if="data[indextr].transactionType === 'Satış'"
                  class="
                    con-vs-chip
                    product-order-status
                    vs-chip-success
                    con-color
                  "
                  style="color: rgba(255, 255, 255, 0.9)"
                >
                  <span class="text-chip vs-chip--text">Satış</span>
                </div>
              </vs-td>
              <vs-td>
                {{ data[indextr].orderNumber }}
              </vs-td>

              <vs-td>
                {{ formatDate(data[indextr].transactionDate) }}
              </vs-td>
              <vs-td>
                {{ data[indextr].debt }}
              </vs-td>
              <vs-td>
                {{ data[indextr].credit }}
              </vs-td>
              <vs-td> %{{ data[indextr].commissionRate }} </vs-td>
              <vs-td>
                {{ formatDate(data[indextr].paymentDate) }}
              </vs-td>

              <vs-td>
                {{ data[indextr].paymentOrderId }}
              </vs-td>

              <vs-td>
                <div
                  v-if="data[indextr].paymentOrderId === 0"
                  class="
                    con-vs-chip
                    product-order-status
                    vs-chip-warning
                    con-color
                  "
                  style="color: rgba(255, 255, 255, 0.9)"
                >
                  <span class="text-chip vs-chip--text">Ödenmedi</span>
                </div>
                <div
                  v-if="data[indextr].paymentOrderId > 0"
                  class="
                    con-vs-chip
                    product-order-status
                    vs-chip-success
                    con-color
                  "
                  style="color: rgba(255, 255, 255, 0.9)"
                >
                  <span class="text-chip vs-chip--text">Ödendi</span>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Finans Verileri"
      :active.sync="popupActive"
    >
      <vs-table search max-items="50" pagination :data="analizData">
        <template slot="thead">
          <vs-th>Tarih</vs-th>
          <vs-th>Evrak No</vs-th>
          <vs-th>İşlem Tipi</vs-th>
          <vs-th>Açıklama</vs-th>
          <vs-th>Tutar</vs-th>
          <vs-th>Ödeme No</vs-th>
          <vs-th>Muhasebe Verisi</vs-th>
          <vs-th>İade</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ formatDate(data[indextr].tarih) }}
            </vs-td>
            <vs-td>
              {{ data[indextr].evrakNo }}
            </vs-td>
            <vs-td>
              {{ data[indextr].tip }}
            </vs-td>
            <vs-td>
              {{ data[indextr].aciklama }}
            </vs-td>
            <vs-td>
              {{ fiyatFormat(data[indextr].debt) }}
            </vs-td>
            <vs-td>
              {{ data[indextr].odemeNo }}
            </vs-td>
            <vs-td>
              {{ fiyatFormat(data[indextr].muhasebeKayitlari) }}
            </vs-td>
            <vs-td>
              {{ fiyatFormat(data[indextr].iadeler) }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Finans Verileri"
      :active.sync="popupActiveStok"
    >
      <vs-table :data="analizDataStok">
        <template slot="thead">
          <vs-th>Stok Kodu</vs-th>
          <vs-th>Toplam Satış</vs-th>
          <vs-th>Toplam Adet</vs-th>
          <vs-th>Ortalama Komisyon</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].stokKodu }}
            </vs-td>
            <vs-td>
              {{ fiyatFormat(data[indextr].toplamSatis) }}
            </vs-td>
            <vs-td>
              {{ data[indextr].toplamAdet }}
            </vs-td>
            <vs-td> %{{ fiyatFormat(data[indextr].ortalamaKomisyon) }} </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="Açık Faturalar"
      :active.sync="popupActiveFatura"
    >
      <vs-table :data="analizDataFatura">
        <template slot="thead">
          <vs-th>Evrak No</vs-th>
          <vs-th>Evrak Sıra</vs-th>
          <vs-th>Sipariş No</vs-th>
          <vs-th>Açıklama</vs-th>
          <vs-th>Tarih</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].evrakSeri }}
            </vs-td>
            <vs-td>
              {{ data[indextr].evrakSira }}
            </vs-td>
            <vs-td>
              {{ data[indextr].orderNumber }}
            </vs-td>
            <vs-td>
              {{ data[indextr].DESCRIPTION }}
            </vs-td>
            <vs-td>
              {{ data[indextr].tarih }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>



<script>
import moment from "moment";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import state from "../../store/state";
import Store from "../../store/store";
import { tr } from "vuejs-datepicker/dist/locale/";
import { BFormDatepicker } from "bootstrap-vue";
export default {
  data() {
    return {
      format: "yyyy-MM-dd",
      tr: tr,
      data: [],
      selectIslemTipi: "",
      baslangic: "",
      formattedDate: "",
      formattedDate1: "",
      bitis: "",
      toplam: 0,
      program: { id: 0, label: "Pazaryeri" },
      check3: "",
      formatOptions: [
        { label: "İndirim", id: "İndirim" },
        { label: "Sipariş", id: "Sipariş" },
        { label: "İade", id: "İade" },
        {
          label: "Vadesinden Önce Yapılan Ödeme",
          id: "Vadesinden Önce Yapılan Ödeme",
        },
        {
          label: "Trendyola Kesilen İade Faturaları",
          id: "Trendyola Kesilen İade Faturaları",
        },
        { label: "Virman", id: "Virman" },
        { label: "Hakedişler", id: "Hakedişler" },
        {
          label: "Trendyolun Kestiği Faturalar",
          id: "Trendyolun Kestiği Faturalar",
        },
      ],
      analizData: [],
      analizDataStok: [],
      analizDataFatura: [],
      toplamSatis: 0,
      toplamIade: 0,
      komisyonOK: 0,
      komisyonNO: 0,
      toplamIndirim: 0,
      popupActive: false,
      popupActiveStok: false,
      popupActiveFatura: false,
      faturaKontrolListesi: [],
    };
  },
  methods: {
    formatDate(timez) {
      //console.log(time)
      //  var date = new Date(1575909015000);
      var date = new Date(parseInt(timez));
      return date.toLocaleString();
      // return date.getDay()+"-"+date.getMonth()+"-"+date.getUTCFullYear();
    },
    finansmanCek(sayfasayisi) {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45,
      });

      var d = new Date(vm.baslangic);
      vm.formattedDate =
        d.getUTCDate() + "/" + (d.getUTCMonth() + 1) + "/" + d.getUTCFullYear();

      var d1 = new Date(vm.bitis);
      vm.formattedDate1 =
        d1.getUTCDate() +
        "/" +
        (d1.getUTCMonth() + 1) +
        "/" +
        d1.getUTCFullYear();

      const soap = require("soap");
      const url = state.sistemAddress;

      //alert(this.selectIslemTipi)

      const args = {
        baslangicTarihi: vm.formattedDate,
        bitisTarihi: vm.formattedDate1,
        program: "Trendyol",
        sayi: sayfasayisi,
        islemTipi: this.selectIslemTipi,
      };
      soap.createClient(url, function (err, client) {
        client.finansVerileriCek(args, function (err, result) {
          console.log(args);
          vm.veriler = JSON.parse(result.finansVerileriCekResult);
          if (vm.veriler.response == "Ok") {
            if (parseInt(vm.veriler.page) < parseInt(vm.veriler.totalPages)) {
              vm.veriler.page = parseInt(vm.veriler.page) + 1;
              vm.finansmanCek(vm.veriler.page);
            } else {
              vs.loading.close("#button-with-loading > .con-vs-loading");
              vs.notify({
                title: "Trendyol Finansman",
                text: "Veriler Çekildi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            }
          } else {
            vs.loading.close("#button-with-loading > .con-vs-loading");
            vs.notify({
              title: "Trendyol Finansman",
              text: "Veriler Çekilemedi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          }
        });
      });
    },
    analiz() {
      var vm = this;
      var vs = this.$vs;

      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading1",
        scale: 0.45,
      });

      var d = new Date(vm.baslangic);
      vm.formattedDate =
        d.getUTCDate() + "/" + (d.getUTCMonth() + 1) + "/" + d.getUTCFullYear();

      var d1 = new Date(vm.bitis);
      vm.formattedDate1 =
        d1.getUTCDate() +
        "/" +
        (d1.getUTCMonth() + 1) +
        "/" +
        d1.getUTCFullYear();

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.selectIslemTipi)
      const args = {
        baslangicTarihi: vm.formattedDate,
        bitisTarihi: vm.formattedDate1,
        program: "Trendyol",
      };
      //console.log(args)
      soap.createClient(url, function (err, client) {
        client.finansalAnaliz(args, function (err, result) {
          vm.veriler = JSON.parse(result.finansalAnalizResult);
          console.log(result.finansalAnalizResult);
          /* vm.analizData=vm.veriler
      vm.toplamSatis=vm.veriler[0].toplamSatis.toFixed(2)
      vm.toplamIade=vm.veriler[0].toplamIade.toFixed(2)
      vm.komisyonOK=vm.veriler[0].KomisyonOdemeKaydiOlusan.toFixed(2)
      vm.komisyonNO=vm.veriler[0].KomisyonOdemeKaydiOlusmayan.toFixed(2)
      vm.toplamIndirim=vm.veriler[0].toplamIndirim.toFixed(2)*/
          //vm.popupActive=true

          // vm.faturaKontrolListesi=JSON.parse(vm.veriler[0].KontrolEdilecekFaturalar)
          //  console.log(vm.faturaKontrolListesi)
          if (vm.veriler[0].response == "Ok") {
            vs.loading.close("#button-with-loading1 > .con-vs-loading");
          }
        });
      });
      //vs.loading.close("#button-with-loading1 > .con-vs-loading")
    },
    stokAnaliz() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      this.popupActiveStok = true;

      const args = {
        program: "SERVIS",
        baslik: "trendyolStokAnaliz",
        ARANAN: "",
        token: Store.state.tokenId,
        companyID: "",
      };
      soap.createClient(url, function (err, client) {
        client.standartSorgular(args, function (err, result) {
          if (result.standartSorgularResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.standartSorgularResult);
          // console.log(vm.veriler)

          vm.analizDataStok = vm.veriler;
        });
      });
    },
    acikFaturalar() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      this.popupActiveFatura = true;

      const args = { program: "Trendyol" };
      soap.createClient(url, function (err, client) {
        client.finansAcikFatura(args, function (err, result) {
          if (result.finansAcikFaturaResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          //console.log(result.finansAcikFaturaResult)
          vm.veriler = JSON.parse(result.finansAcikFaturaResult);

          vm.analizDataFatura = vm.veriler;
        });
      });
    },
    fiyatFormat(tutar) {
      return tutar.toFixed(2);
    },
    analizListe() {
      var vm = this;
      var vs = this.$vs;

      /* vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading1",
        scale: 0.45
      })*/

      var d = new Date(vm.baslangic);
      vm.formattedDate =
        d.getUTCDate() + "/" + (d.getUTCMonth() + 1) + "/" + d.getUTCFullYear();

      var d1 = new Date(vm.bitis);
      vm.formattedDate1 =
        d1.getUTCDate() +
        "/" +
        (d1.getUTCMonth() + 1) +
        "/" +
        d1.getUTCFullYear();

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.selectIslemTipi)
      const args = {
        baslangicTarihi: vm.formattedDate,
        bitisTarihi: vm.formattedDate1,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.finanAnalizListe(args, function (err, result) {
          vm.veriler = JSON.parse(result.finanAnalizListeResult);
          vm.analizData = vm.veriler;
          console.log(vm.veriler);
          /*vm.toplamSatis=vm.veriler[0].toplamSatis.toFixed(2)
      vm.toplamIade=vm.veriler[0].toplamIade.toFixed(2)
      vm.komisyonOK=vm.veriler[0].KomisyonOdemeKaydiOlusan.toFixed(2)
      vm.komisyonNO=vm.veriler[0].KomisyonOdemeKaydiOlusmayan.toFixed(2)
      vm.toplamIndirim=vm.veriler[0].toplamIndirim.toFixed(2)*/
          vm.popupActive = true;

          // vm.faturaKontrolListesi=JSON.parse(vm.veriler[0].KontrolEdilecekFaturalar)
          //  console.log(vm.faturaKontrolListesi)
        });
      });
      //vs.loading.close("#button-with-loading1 > .con-vs-loading")
    },
    toplama() {
      var vm = this;
      var sayi = 0;
      this.data.forEach((element) => {
        sayi = sayi + parseInt(element.satisAdet);
      });
      return sayi;
      // this.toplam=parseInt(this.toplam)+parseInt(d)
      // return this.toplam
      //console.log(this.toplam)
    },
    finansListele() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      var d = new Date(vm.baslangic);
      vm.formattedDate =
        d.getUTCDate() + "/" + (d.getUTCMonth() + 1) + "/" + d.getUTCFullYear();

      var d1 = new Date(vm.bitis);
      vm.formattedDate1 =
        d1.getUTCDate() +
        "/" +
        (d1.getUTCMonth() + 1) +
        "/" +
        d1.getUTCFullYear();
      // console.log(vm.formattedDate)
      const args = {
        baslangicTarihi: vm.formattedDate,
        bitisTarihi: vm.formattedDate1,
        program: "Trendyol",
      };
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.finansalveriListele(args, function (err, result) {
          vm.veriler = JSON.parse(result.finansalveriListeleResult);
          //  console.log(vm.veriler)
          vm.data = vm.veriler;
          // vm.eslesenStokListesi=vm.veriler
        });
      });
    },
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    BFormDatepicker,
  },
};
</script>
